import { Grid, Paper, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axios/axiosInstance";
import API from "../../../config/apiconfig";
import { useDispatch } from "react-redux";
import { userApiLoader } from "../../../action/loaderActions";
import {
  RadialBarChart,
  RadialBar,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const Dashboardtab = () => {
  const dispatch = useDispatch();
  const [isData, setIsData] = useState([]);

  const getDashboardDetails = () => {
    dispatch(userApiLoader({ isApiLoader: true }));
    axiosInstance
      .get(
        `${API.USER_MANAGEMENT_API_BASE_URL}${API.HEALTH_TRACKER}${API.HEALTH_DATA}`
      )
      .then((res) => {
        setIsData(res?.data?.data || []);
        dispatch(userApiLoader({ isApiLoader: false }));
      })
      .catch((err) => {
        console.log(err);
        dispatch(userApiLoader({ isApiLoader: false }));
      });
  };

  useEffect(() => {
    getDashboardDetails();
  }, []);

  return (
    <Box className="px-4 py-6 bg-gray-50 h-full overflow-y-auto">
      <Typography variant="h5" className="font-bold mb-6 text-gray-800">
        Health Tracker Overview
      </Typography>

      <Grid container spacing={3}>
        {isData.length > 0 ? (
          isData.map((item) => {
            const percentage =
              item.goal > 0
                ? Math.min((item.achieved / item.goal) * 100, 100)
                : 0;

            const chartData = [
              {
                name: item.metric,
                value: percentage,
                fill: "#42a5f5"
              }
            ];

            return (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Paper
                  elevation={2}
                  className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                >
                  <Typography
                    variant="subtitle1"
                    className="font-semibold text-center mb-2 text-gray-700"
                  >
                    {item.metric}
                  </Typography>
                  <ResponsiveContainer width="100%" height={150}>
                    <RadialBarChart
                      cx="50%"
                      cy="50%"
                      innerRadius="60%"
                      outerRadius="100%"
                      barSize={12}
                      data={chartData}
                    >
                      <RadialBar
                        minAngle={15}
                        clockWise
                        background
                        dataKey="value"
                        label={{
                          position: "center",
                          fill: "#333",
                          fontSize: 16,
                          formatter: () =>
                            `${Math.round(percentage)}%`
                        }}
                      />
                      <Tooltip />
                    </RadialBarChart>
                  </ResponsiveContainer>
                  <Typography
                    variant="body2"
                    className="text-center mt-2 text-sm text-gray-600"
                  >
                    {item.achieved}/{item.goal} {item.unit}
                  </Typography>
                </Paper>
              </Grid>
            );
          })
        ) : (
          <Grid item xs={12}>
            <Paper elevation={2} className="p-6 text-center text-gray-500">
              No health data available.
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Dashboardtab;
